/**
 * Brand tags exposed to brands after the launch of the brand practices/identiy split in 2023
 * https:www.notion.so/faire/Brand-values-tag-definitions-Eng-Spec-93b476e4673447e79d413cea3bce48bc
 */
export const ALLOWED_BRAND_TAG_DEFINITIONS = 'ALLOWED_BRAND_TAG_DEFINITIONS';
